import * as i0 from '@angular/core';
import { Directive, ContentChildren, Input, Output, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { ChangeableItemDirective, ChangeableItemsHelper } from '@angular-react/fabric/lib/components/core';
import { CommonModule } from '@angular/common';

// Copyright (c) Microsoft Corporation. All rights reserved.
class GroupItemDirective extends ChangeableItemDirective {
    get onChildItemChanged() {
        return this.changeableItemsHelper && this.changeableItemsHelper.onChildItemChanged;
    }
    get onItemsChanged() {
        return this.changeableItemsHelper && this.changeableItemsHelper.onItemsChanged;
    }
    ngAfterContentInit() {
        this.changeableItemsHelper = new ChangeableItemsHelper(this.groupItemsDirectives, this, nonSelf => {
            this.children = nonSelf;
        });
    }
    ngOnDestroy() {
        this.changeableItemsHelper.destroy();
    }
}
/** @nocollapse */ GroupItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: GroupItemDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ GroupItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.1", type: GroupItemDirective, selector: "fab-group-item", inputs: { name: "name", startIndex: "startIndex", count: "count", children: "children", level: "level", isCollapsed: "isCollapsed", isShowingAll: "isShowingAll", isDropEnabled: "isDropEnabled", data: "data", ariaLabel: "ariaLabel", hasMoreData: "hasMoreData", onItemsChanged: "onItemsChanged" }, outputs: { onChildItemChanged: "onChildItemChanged" }, queries: [{ propertyName: "groupItemsDirectives", predicate: GroupItemDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: GroupItemDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'fab-group-item' }]
        }], propDecorators: { groupItemsDirectives: [{
                type: ContentChildren,
                args: [GroupItemDirective]
            }], name: [{
                type: Input
            }], startIndex: [{
                type: Input
            }], count: [{
                type: Input
            }], children: [{
                type: Input
            }], level: [{
                type: Input
            }], isCollapsed: [{
                type: Input
            }], isShowingAll: [{
                type: Input
            }], isDropEnabled: [{
                type: Input
            }], data: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], hasMoreData: [{
                type: Input
            }], onChildItemChanged: [{
                type: Output
            }], onItemsChanged: [{
                type: Input
            }] } });

// Copyright (c) Microsoft Corporation. All rights reserved.
const components = [GroupItemDirective];
class FabGroupModule {
}
/** @nocollapse */ FabGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ FabGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabGroupModule, declarations: [GroupItemDirective], imports: [CommonModule], exports: [GroupItemDirective] });
/** @nocollapse */ FabGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabGroupModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: components,
                    exports: components,
                    schemas: [NO_ERRORS_SCHEMA],
                }]
        }] });

// Copyright (c) Microsoft Corporation. All rights reserved.

/**
 * Generated bundle index. Do not edit.
 */

export { FabGroupModule, GroupItemDirective };
